/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React,{useEffect,useCallback,useState,useContext,useMemo} from 'react'
import { connect } from 'react-redux'
import CartItemShimmer from '../../Components/CartItemCard/CartItemShimmer'
import { useNavigate } from 'react-router-dom';
import { DistributorActions } from '../../redux/actions'
import { WishlistedProduct } from '../../redux/helper/AddWishlist'
import { distributorService } from '../../service/distributor.service'
import EmptyWishlistScreen from '../Wishlist/EmptyScreen'
import CartListing from './CartListing'
import './style.css'
import { v4 as uuid } from 'uuid';
import ReactModal from 'react-modal'
import Success from '../../Components/OrderSuccess'
import HeaderContext from '../../Components/Context/HeaderContext'
import Draft from '../../Components/OrderSuccess/Draft'

export const CartManagement = ({GetCartItems,Cart,GetCalculation,Calculation,Getprofile,Profile}) => {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const location = useNavigate();
    const [wishProducts, setwishProducts] = useState([]);
    const [totalCount, settotalCount] = useState({});
    const [proposedCount, setproposedCount] = useState({});
    const [orderSuccess, setorderSuccess] = useState([]);
    const [addressSelection, setaddressSelection] = useState({});
    const [fromDeal, setfromDeal] = useState(false)
    const [isSpecialOffer, setIsSpecialOffer] = useState(false);
    const [defaultAddress, setdefaultAddress] = useState({})
    const [adorCaashConfig, setAdorCashConfig] = useState({})
    const [addressList, setaddressList] = useState([])

    const [selectedAddressObj, setselectedAddressObj] = useState({
        billing_address:{},
        shipping_address:{},
        praposedAmount:0
    })
    const [cartCount, setcartCount] = useState({})
    const [loading, setloading] = useState(true);
    const [initialrender, setinitialrender] = useState(0)
    const [addressDropdown, setaddressDropdown] = useState({
        shipping_address:[],
        billing_address:[]
    })
    const [orderFlow, setorderFlow] = useState({
        order_type:'',
        selectAddressClicked:false,
        viewFinancialSummary:false,
        addDocumentation:false,
    })
    const [OrderType, setOrderType] = useState(false)
    const [isTradeEUB, setIsTradeEUB] = useState(true)
    const [cashDiscountMessage, setCashDiscountMessage] = useState('')
    const [disabledTradeEUB, setDisabledTradeEUB] = useState([])
    const [specialcondition, setSpecialcondition] = useState([])

    const handlewish=async()=>{
        const list= await WishlistedProduct();
        setwishProducts(list)
    }
    const checkAssistant = ()=>{
        const item = JSON.parse(localStorage.getItem('user'))?.profile?.logged_in_user;
        return item==='distributor'?false:true;
    }
    const  handleshipbilladdress=(addressList)=>{
        let shipping_address=[];
        let billing_address=[];
        if(addressList.length>0){
            addressList.map((item,i)=>{
                const unique_id = uuid();

                if(item.SITE_USE_CODE==="BILL_TO"){
                    item['unique_id']=`${unique_id}-${i}`
                    billing_address.push(item)
                }else{
                    item['unique_id']=`${unique_id}-${i}`
                    shipping_address.push(item)

                }
            })
        }
        setaddressDropdown({
            shipping_address:shipping_address,
            billing_address:billing_address
        })
        return{
            shipping_address,billing_address
        }
    }
    const handleErrorMessage = ()=>{
        SetErrorMessage('Something went wrong');
        setcolorValue(true);
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);

        }, 1000);
    }
    const ConstructAddresHandler=useCallback(
        (items) => {
            if(initialrender===0){
                let obj={...selectedAddressObj}
                if(Object.keys(obj.billing_address).length===0 && Object.keys(obj.shipping_address).length===0 ){
                    distributorService.Getaddress().then((res)=>{
                        if(!res.error && res.data.success_status){
                            const addr = handleshipbilladdress(res?.data?.data.data);
                            setaddressList(addr)
                            items && Object.keys(items).map((val)=>{
                                if(items[val]){
                                    obj[items[val].item_id]={
                                        billing_address:addr?.billing_address[0],
                                        shipping_address:addr?.shipping_address[0],
                                        praposedAmount:0
                                    }
                                }
        
                            })
                        }
                    })
                }
                setselectedAddressObj(obj);
                setdefaultAddress(obj)            }
        },
        [],
    )
    const handleCartCount=useCallback(
        (items,key) => {
            let obj ={...cartCount}
            let propose={...proposedCount}
            let address={...addressSelection};
            items && items.map((val)=>{
                if(obj[val.INVA]){
                    obj[val.item_id]+=Number(val.quantity);
                }else{
                    obj[val.item_id]=Number(val.quantity)
                    propose[val.item_id]=val.proposed_amount;
                }
            })
            setcartCount(obj);
            setproposedCount(propose);
            if(key===undefined){
                ConstructAddresHandler(items);

            }
            setinitialrender(initialrender+1)
            return obj; 
        },
        [],
    )
    const handleFetch=useCallback(
        (key) => {
            GetCartItems(key).then((res)=>{
                if(res?.data?.data?.cart_items){
                    setDisabledTradeEUB(res?.data?.data?.cart_items?.map((item) => (item.trade_eub)))
                }
                if(res?.data?.data?.cart_items){
                    setSpecialcondition(res?.data?.data?.cart_items?.map((item) => (item.offer_type)))
                }
                GetCalculation();
                setloading(false);
                handlewish();
                if(res?.data?.data?.cart_items?.length>0){
                    handleCartCount(res?.data?.data?.cart_items,key);
                }
                if(res?.data?.data?.summary?.special_offer_exist){
                    localStorage.setItem('FromOffer','1');
                    setIsSpecialOffer(true)
                    const CheckingArray = res?.data?.data.cart_items.length>0 && res?.data?.data.cart_items.filter((item => item.offer_type === 'Bulk' ))
                    if(CheckingArray.length > 0){
                        orderFlow.order_type='Trade Order'
                        setorderFlow(orderFlow)
                        setOrderType(true)
                        setIsTradeEUB(false)
                    }

                }else{
                    GetCartItems('item','1').then((res)=>{
                        if(res.error){
                            handleErrorMessage()
                        }
                    })
                    localStorage.removeItem('FromOffer')
                }
                if(res?.data?.data?.summary?.special_offer_exist && orderFlow.order_type===''){
                    setOrderType(true);
                    setfromDeal(true)
                }

            });
            Getprofile()
        },
        [],
    )
   
    useEffect(() => {
        handleFetch()
    }, [handleFetch])
    const handleFlowState=async (key,value)=>{
        orderFlow[key] = value
        setorderFlow((prevState)=>({
            ...prevState,
            [key]:value
        }))
        // setorderFlow(orderFlow)
        if(key === 'selectAddressClicked' && value == true){
            const update = await distributorService.BulkAddProducts(addAddress(Cart.items));
            if(update.error || !update.data.success_status){
                SetErrorMessage(update?.message?.response?.data?.message || update?.message?.message);
                setcolorValue(true)
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue(false);
                }, 3000);
            }else {
                handleFetch('key')
            };

        }
        
    }
    const addAddress=(item)=>{
        const arr=[]
        item.map((val)=>{
            val['BILLING_ADDRESS']=selectedAddressObj[val.item_id].billing_address,
            val['SHIPPING_ADDRESS']=selectedAddressObj[val.item_id].shipping_address,
            arr.push(val)

        })
        return arr;
    }
    const [adorCashCheck, setadorCashCheck] = useState(false);

    const CreateOrder=async(doc)=>{
        let payload = {};
        payload['cart_items']=addAddress(Cart.items)
        payload['po_number']=doc.PO_details
        payload["po_document"] = doc.attach_po
        payload["order_type"] = orderFlow.order_type==='Trade EUB Order'?'EUB':'Trade'
        if (doc.eu_name)
            payload['eu_name'] = doc.eu_name
        payload['assistant_user']=checkAssistant()===true?JSON.parse(localStorage.getItem('user'))?.profile?.internal_user_id:'';
        payload['user_type']=checkAssistant()===true?'assistant':'distributor';
        payload["ador_cash_used"] = adorCashCheck?Calculation?.summary?.order_avail_ador_cash:"0"
        if (doc.instruction != "")
            payload['instruction'] = doc.instruction
        if (doc.attach_file.length != 0)
            payload["po_additional_document"] = doc.attach_file;
        const create = await distributorService.CreateOrder(payload);
        if(!create.error && create.data.success_status){
            setorderSuccess(create?.data?.order_numbers);
            setAdorCashConfig(create?.data?.ador_cash_config);
            setCashDiscountMessage(create?.data?.cash_discount_message)
            GetCartItems()
            // setTimeout(() => {
            //     setorderSuccess([]);
            //     location(`/orders`);
            // }, 20000);
        }else{
            console.log(create);
            SetErrorMessage(create?.message?.response?.data?.message);
            setcolorValue(true)
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
                if(create?.message?.response?.data?.empty_cart){
                    location(`/products`)
                }
            }, 3000);
        }
        localStorage.removeItem('FromOffer');

        return create
    
    }
    return (
        <div className='pb-[132px]'>
            <>{loading && <CartItemShimmer/>}</>
            {!loading && Cart.hasOwnProperty('items') && Cart.items.length === 0 &&
            <div className='pt-9 sm:px-[128px] px-4'>
                <EmptyWishlistScreen cart='cart'/>
            </div>}
            <>
                {!loading && Cart.hasOwnProperty('items') && Cart.items.length > 0 && 
                <CartListing Cart={Cart} 
                    GetCartItems={handleFetch}
                    wishProducts={wishProducts}
                    totalCount={totalCount}
                    cartCount={cartCount}
                    setcartCount={setcartCount}
                    orderFlow={orderFlow}
                    handleFlow={handleFlowState}
                    addressDropdown={addressDropdown}
                    selectedAddressObj={selectedAddressObj}
                    setselectedAddressObj={setselectedAddressObj}
                    proposedCount={proposedCount}
                    setproposedCount={setproposedCount}
                    Calculation={Calculation}
                    OrderType={OrderType}
                    setOrderType={setOrderType}
                    fromDeal={fromDeal}
                    setdefaultAddress={setdefaultAddress}
                    defaultAddress={addressList}
                    adorCashCheck={adorCashCheck}
                    setadorCashCheck={setadorCashCheck}
                    GetCalculation={GetCalculation}
                    CreateOrder={CreateOrder}
                    isTradeEUB={isTradeEUB}
                    isSpecialOffer={isSpecialOffer}
                    setinitialrender={setinitialrender}
                    Privilages={Profile?.profile?.PRIVILAGES||[]}
                    disabledTradeEUB={disabledTradeEUB}
                    specialcondition={specialcondition}
                />}
            </>
            <ReactModal style={{overFlow:'auto'}} isOpen={orderSuccess.length > 0}>
                {checkAssistant()===true?
                    <Draft orderSuccess={orderSuccess} orderFlow={orderFlow}/>:
                    <Success cashDiscountMessage={cashDiscountMessage} orderSuccess={orderSuccess} orderFlow={orderFlow} adorCaashConfig={adorCaashConfig} Privilages={Profile?.profile?.PRIVILAGES||[]} />}
            </ReactModal>
        </div>
    )
}

const mapStateToProps = (state) => {
    const { Cart,Calculation,Profile}=state;
    return { Cart,Calculation,Profile }

};

const mapDispatchToProps = {
    GetCartItems:DistributorActions.GetCartItems,
    GetCalculation:DistributorActions.GetCartCalculation,
    Getprofile:DistributorActions.GetprofileData


}

export default connect(mapStateToProps, mapDispatchToProps)(CartManagement)